import { Injectable } from '@angular/core';
import { environment } from 'src/environments/local/environment';
import { CompanyLookupResponseModel } from 'src/app/models/company.model';

@Injectable()
export class StorageService {
  constructor() {
  }

  private makeid(length: number): string {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  setCookie(cookie: string, val: string): string {
    if (!environment.production) {
      document.cookie = cookie + '=' + val + ';path=/;';
    } else {
      document.cookie = cookie + '=' + val + ';path=/;samesite=none;secure;';
    }

    return val;
  }

  destroyCookie(cookie: string): void {
    document.cookie =
      cookie + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  getCookie(cname: string): string {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  generateNewEC(): string {
    return this.setCookie('c_idin_ec', this.makeid(20));
  }

  getEC(): string {
    return this.getCookie('c_idin_ec');
  }

  setTransactionID(value: string): string {
    return this.setCookie('c_idin_transaction_id', value);
  }

  getTranactionID(): string {
    return this.getCookie('c_idin_transaction_id');
  }

  setMerchantReference(value: string): string {
    return this.setCookie('c_idin_merchant_reference', value);
  }

  getMerchantReference(): string {
    return this.getCookie('c_idin_merchant_reference');
  }

  setLeadId(value: string): string {
    return this.setCookie('c_lead_id', value);
  }

  getLeadId(): string {
    return this.getCookie('c_lead_id');
  }

  setCompany(value: CompanyLookupResponseModel): string {
    return this.setCookie('c_company', JSON.stringify(value));
  }

  getCompany(): CompanyLookupResponseModel {
    return JSON.parse(this.getCookie('c_company'));
  }
}
